/**
 * Custom Site Specific Javascript
 *
 * This file is to add custom features to the website without having to modify
 * core/common assets. Define a custom class, and build new or overwrite
 * existing methods to create custom functionality.
 */

import { modal } from "commonAssets/lib/modal.js";
import { toggleFieldAttributeV2 } from "commonAssets/lib/toggleFieldAttributeV2";

/**
 * Initializes a claim object.
 *
 * @param {Object} claim - The claim object to be initialized.
 * @returns {Object} The initialized claim object.
 */
export function customInitClaim(claim) {
    console.log("[Initiate claim]...");

    // Dom updates
    // if #first_name and #last_name has values, disable
    const firstNameInput = document.getElementById("first_name");
    const lastNameInput = document.getElementById("last_name");
    if (firstNameInput && firstNameInput.value) {
        firstNameInput.setAttribute("disabled", "disabled");
    }
    if (lastNameInput && lastNameInput.value) {
        lastNameInput.setAttribute("disabled", "disabled");
    }

    // AGENT START
    // Enforce $2,500 maximum and $0.01 minimum for Documented Losses total amount
    const lossesTotalInput = document.getElementById("doc_losses_total_amount");
    if (lossesTotalInput) {
        const MAX_TOTAL = 2500;
        const MIN_TOTAL = 0.01;
        // Hint native validation/UIs
        lossesTotalInput.setAttribute("max", String(MAX_TOTAL));
        lossesTotalInput.setAttribute("min", String(MIN_TOTAL));

        const clampToBounds = () => {
            const raw = lossesTotalInput.value;
            if (raw == null || raw === "") return;
            const parsed = parseFloat(String(raw).replace(/[^0-9.\-]/g, ""));
            if (Number.isFinite(parsed)) {
                if (parsed > MAX_TOTAL) {
                    lossesTotalInput.value = String(MAX_TOTAL);
                } else if (parsed < MIN_TOTAL) {
                    lossesTotalInput.value = String(MIN_TOTAL);
                }
            }
        };

        lossesTotalInput.addEventListener("input", clampToBounds);
        lossesTotalInput.addEventListener("change", clampToBounds);
        lossesTotalInput.addEventListener("blur", clampToBounds);
    }
    
    // Toggle "Not Reimbursed" field required attribute based on "Incurred" checkbox
    const docLossesIncurred = document.getElementById('doc_losses_incurred_0');
    docLossesIncurred.addEventListener('click', function () {
        toggleFieldAttributeV2(document.getElementById('doc_losses_not_reimbursed_0'), 'required', this.checked);
    });

    // AGENT END

    return claim;
}

/**
 * Custom function to load a member.
 *
 * @param {Object} claim - The member object to be loaded.
 * @returns {Object} - The loaded member object.
 */
export function customLoadMember(claim) {
    console.log("[Load class member]...");
    // custom code goes here
    return claim;
}

/**
 * Processes a claim for a custom member.
 *
 * @param {Object} claim - The claim to be processed.
 * @returns {Object} The processed claim.
 */
export function customProcessClaim(claim) {
    console.log("[Process claim]...");
    // Supporting Documentation check
    const hasFiles =
        (claim.uploads && claim.uploads.length > 0) ||
        (claim.data?.claim_id &&
            claim.class_member?.claim_files &&
            claim.class_member.claim_files.length > 0);

    // Enforce supporting documentation presence
    if (!hasFiles) {
        claim.flags = claim.flags || {};
        claim.flags.valid = false;
        if (typeof modal === "function") {
            modal(
                "Supporting Documentation Required",
                "Please upload supporting documentation to proceed with your claim submission."
            );
        }
    }

    return claim;
}
